export default class ExpensesReport {
  // estimate_total: number = 0;
  // expenses_total: number = 0;
  // others: number = 0;
  // others_total: number = 0;
  // expensesList: {
  //   month: string;
  //   sales: number;
  // }[] = [];

  // DEV: データ詳細 コメント表示
  estimateTotal: number = 0; //見積合計額,
  expenseTotal: number = 0; //経費合計額,
  othersEstimateTotal: number = 0; //その他 見積合計額
  othersEstimateTotalRate: number = 0; //その他 見積率
  othersExpenseTotal: number = 0; //その他 経費合計額,
  othersExpenseTotalRate: number = 0; //その他 経費率,
  others: number = 0; //その他 総数,
  expenseImportantList: {
    //詳細表示のある経費カテゴリを個別行に表示,
    name: string; //カテゴリ名,
    estimate: number; //見積金額,
    estimateRate: number; //見積率,
    expense: number; //経費額,
    expenseRate: number; //経費率
  }[] = [];
  colors?: string[] = []; // 色表示用のデータを追加
}
